import { render } from "./PersonalisationLandingPage.vue?vue&type=template&id=74446527&scoped=true"
import script from "./PersonalisationLandingPage.vue?vue&type=script&lang=js"
export * from "./PersonalisationLandingPage.vue?vue&type=script&lang=js"

import "./PersonalisationLandingPage.vue?vue&type=style&index=0&id=74446527&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74446527"]])

export default __exports__